import {
  GET_ACTIVE_ORDER_CARD_PAGINATION_READ, GET_ACTIVE_ORDER_CARD_PAGINATION_UPDATE, GET_ACTIVE_ORDER_CARD_PAGINATION_RESET,
  GET_ACTIVE_ORDER_GRID_PAGINATION_READ, GET_ACTIVE_ORDER_GRID_PAGINATION_UPDATE, GET_ACTIVE_ORDER_GRID_PAGINATION_RESET,

  GET_ALLOCATED_ORDER_CARD_PAGINATION_READ, GET_ALLOCATED_ORDER_CARD_PAGINATION_UPDATE, GET_ALLOCATED_ORDER_CARD_PAGINATION_RESET,
  GET_ALLOCATED_ORDER_GRID_PAGINATION_READ, GET_ALLOCATED_ORDER_GRID_PAGINATION_UPDATE, GET_ALLOCATED_ORDER_GRID_PAGINATION_RESET,

  GET_VEHICLE_REPORTING_CARD_PAGINATION_READ, GET_VEHICLE_REPORTING_CARD_PAGINATION_UPDATE, GET_VEHICLE_REPORTING_CARD_PAGINATION_RESET,
  GET_VEHICLE_REPORTING_GRID_PAGINATION_READ, GET_VEHICLE_REPORTING_GRID_PAGINATION_UPDATE, GET_VEHICLE_REPORTING_GRID_PAGINATION_RESET,
} from "../types/paginationType";

export const updatePagination = (data) => {

  let typeToCheck = data[1];
  if (typeToCheck.localeCompare('GET_ACTIVE_ORDER_CARD_PAGINATION_UPDATE') == 0) {
    return {
      type: GET_ACTIVE_ORDER_CARD_PAGINATION_UPDATE,
      payload: data[0]
    }
  }
  else if (typeToCheck.localeCompare('GET_ACTIVE_ORDER_GRID_PAGINATION_UPDATE') == 0) {
    return {
      type: GET_ACTIVE_ORDER_GRID_PAGINATION_UPDATE,
      payload: data[0]
    }
  }
  else if (typeToCheck.localeCompare('GET_ALLOCATED_ORDER_CARD_PAGINATION_UPDATE') == 0) {
    return {
      type: GET_ALLOCATED_ORDER_CARD_PAGINATION_UPDATE,
      payload: data[0]
    }
  }
  else if (typeToCheck.localeCompare('GET_ALLOCATED_ORDER_GRID_PAGINATION_UPDATE') == 0) {
    return {
      type: GET_ALLOCATED_ORDER_GRID_PAGINATION_UPDATE,
      payload: data[0]
    }
  }
  else if (typeToCheck.localeCompare('GET_VEHICLE_REPORTING_CARD_PAGINATION_UPDATE') == 0) {
    return {
      type: GET_VEHICLE_REPORTING_CARD_PAGINATION_UPDATE,
      payload: data[0]
    }
  }
  else if (typeToCheck.localeCompare('GET_VEHICLE_REPORTING_GRID_PAGINATION_UPDATE') == 0) {
    return {
      type: GET_VEHICLE_REPORTING_GRID_PAGINATION_UPDATE,
      payload: data[0]
    }
  }
}

export const readPagination = () => {

  //dispatch({ type: GET_ACTIVE_ORDER_GRID_PAGINATION_UPDATE, data })
  //console.log(data[0])
  return {
    type: GET_ACTIVE_ORDER_CARD_PAGINATION_READ,
    //payload: data[0]
  }
}

export const resetPagination = (id) => async (dispatch) => {
}